/**
 * Utility to disable scroll-to-change behavior on number inputs
 * This blurs the input when scrolling over it, allowing page scroll but preventing value change
 */

// Function to handle wheel events on number inputs
const handleNumberInputWheel = (e: WheelEvent) => {
  const target = e.target as HTMLElement

  // Check if the target is a number input that's currently focused
  if (
    target instanceof HTMLInputElement &&
    target.type === 'number' &&
    document.activeElement === target
  ) {
    // Blur the input to prevent the value from changing
    // The page will still scroll normally
    target.blur()
  }
}

/**
 * Initialize the global handler for all number inputs
 * Call this once when the app starts
 */
export const initializeNumberInputScrollPrevention = () => {
  // Add event listener to document with capture phase
  document.addEventListener('wheel', handleNumberInputWheel, { passive: true, capture: true })

  return () => {
    document.removeEventListener('wheel', handleNumberInputWheel, { capture: true })
  }
}
